import { render, staticRenderFns } from "./modSillonesClinica.vue?vue&type=template&id=ea924c06"
import script from "./modSillonesClinica.vue?vue&type=script&lang=js"
export * from "./modSillonesClinica.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports